module.exports = __webpack_public_path__ + "static/scriptteam.e5ba6faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scriptteam.jpg
// module id = 360
// module chunks = 35783957827783